import { ADMIN_USER } from '@iotize/tap/configurator';

import { GET, POST, PUT } from '../annotations';
import { ascii, uint16 } from '../converters';
import { TapServerError } from '../tap-server-error';
import { CallContext, VirtualTap } from '../virtual-tap-server';

// @LWM2MService('')
export class GroupService {
  constructor(public server: VirtualTap) {}

  @GET({
    path: '/1025/{groupId}/0',
    responseType: ascii,
  })
  public getName(context: CallContext) {
    // console.log('FIND NAME: ', context.getPathParameter('groupId'), this.server.configExplorer.allProfiles);
    return this.getUserOrProfileFromId(context.getPathParameter('groupId'))
      .username;
  }

  @PUT({
    path: '/1025/{groupId}/0',
    auth: ['admin'],
    payloadType: ascii,
  })
  public putName(context: CallContext<string>) {
    // console.log('FIND NAME: ', context.getPathParameter('groupId'), this.server.configExplorer.allProfiles);
    const groupId = context.getPathParameter('groupId');
    const profile = this.getUserOrProfileFromId(groupId);
    const newUsername = context.body;
    if (
      this.server.configExplorer.allUserOrProfiles.find(
        (p) => p.username === newUsername && p.id !== groupId
      )
    ) {
      // Username is already used by another profile
      throw TapServerError.notAcceptable();
    }
    profile.username = context.body;
  }

  @GET({
    path: '/1025/{groupId}/4',
    responseType: uint16,
  })
  public getSessionLifetime(context: CallContext) {
    return this.getUserOrProfileFromId(context.pathParameters.groupId).lifeTime;
  }

  @PUT({
    path: '/1025/{groupId}/4',
    auth: ['admin'],
    payloadType: uint16,
  })
  public putSessionLifetime(context: CallContext<number>) {
    this.getUserOrProfileFromId(context.pathParameters.groupId).lifeTime =
      context.body;
  }

  @POST({
    path: '/1025/{groupId}/2',
    responseType: uint16,
  })
  public postPassword(context: CallContext) {
    const newPassword: Uint8Array = context.body;
    const groupId = context.pathParameters.groupId;
    const profileId = this.getUserOrProfileFromId(
      context.pathParameters.groupId
    );
    if (
      this.server.sessionState.groupId !== groupId &&
      this.server.sessionState.groupId !== ADMIN_USER.id
    ) {
      throw TapServerError.unauthorized();
    }
    profileId.key = newPassword;
  }

  @GET({
    path: '/1025/{groupId}/5',
    responseType: uint16,
  })
  public getAlias(context: CallContext) {
    const groupId = context.pathParameters.groupId;
    const parentUser = this.server.configExplorer.allProfiles.find(
      (profile) => {
        if (profile.id === groupId) {
          return true;
        }
        return !!profile.users?.find((u) => {
          return u.id === groupId;
        });
      }
    );
    if (!parentUser) {
      throw TapServerError.notFound();
    }
    return parentUser.id;
  }

  @PUT({
    path: '/1025/{groupId}/5',
    auth: ['admin'],
    payloadType: uint16,
  })
  public putAlias(context: CallContext<number>) {
    const user = this.getUserOrProfileFromId(context.pathParameters.groupId);
    const newGroupId = context.body;
    this.server.configExplorer.changeUserAlias(user.id, newGroupId);
  }

  @POST({
    path: '/1025/{groupId}/65535',
    responseType: uint16,
    configModeRequired: true,
    auth: ['admin', 'supervisor'],
  })
  public createUser(context: CallContext) {
    const userId = context.pathParameters.groupId;
    context.server.configExplorer.createProfile(userId);
  }

  private getUserOrProfileFromId(groupId: number) {
    const profile = this.server.configExplorer.findUserOrProfileById(groupId);
    if (!profile) {
      throw TapServerError.notFound();
    }
    return profile;
  }
}
